module.exports = __webpack_public_path__ + "static/media/13.b254b338.jpg";